import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=233d756e&scoped=true&"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=233d756e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d756e",
  null
  
)

export default component.exports